import { Link } from 'react-router-dom';
import { Button } from '@design-system/Button';
import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import * as P from '@/constants/paths';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';
import { useUserStore } from '@/hooks/useUserStore';
import { Player } from '@lottiefiles/react-lottie-player';
import SuccessLottie from '@/assets/success-black.json';

export const RegistrationSuccess = () => {
  const { user: userData } = useUserStore();
  const successRedirectionPath = userData ? P.HOME_PATH : P.LOGIN_PATH;

  return (
    <FullScreenPageContainer hideBackButton centerContent data-testid="registrationSuccess-container">
      <Player
        autoplay
        src={SuccessLottie}
        keepLastFrame
        className="w-52 h-52 object-cover"
        data-testid="registrationSuccess-animation"
      />
      <h2 className="text-3xl font-sans md:text-center mb-4 font-medium text-center" data-testid="registrationSuccess-title">
        Success !
      </h2>
      <div className="flex justify-center" data-testid="registrationSuccess-description">
        <p className="font-sans md:text-center">
          Your Kit has been successfully registered
        </p>
      </div>
      <Link to={successRedirectionPath} data-testid="registrationSuccess-actionLink">
        <Button
          type="button"
          className="w-full py-3 text-white font-semibold bg-black rounded-lg mt-8"
          data-testid="registrationSuccess-actionButton"
        >
          {userData ? 'Track your sample' : 'Login to my account'}
        </Button>
      </Link>
      <div className="flex justify-center mt-4" data-testid="registrationSuccess-familyInfo">
        <p className="font-sans text-center">
          If you are registering a kit for a family member, tap{' '}
          <a
            style={{
              textDecoration: 'underline',
              textDecorationColor: 'black',
              textDecorationThickness: '1.4px',
              textUnderlineOffset: '2px',
            }}
            href={linkoutConfigs.multipleKit}
            onMouseDown={(e) => e.preventDefault()}
            data-testid="registrationSuccess-multipleKitLink"
          >
            here
          </a>{' '}
          for more information.
        </p>
      </div>
    </FullScreenPageContainer>
  );
};
